import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getUser, saveUser, deleteUser } from './actions'
import App from '../common/app'
import User from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="user" {...getState()} {...appActions}>
      <User {...getState().user} deleteUser={deleteUser} saveUser={saveUser} />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  getUser(context.params.userId)
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
